import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTableFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.75 10.85c0 .22.18.4.4.4h7.95a.4.4 0 0 0 .4-.4V8.026c0-3.305-2.123-5.526-5.283-5.526H13.15a.4.4 0 0 0-.4.4zM10.85 11.25a.4.4 0 0 0 .4-.4V2.9a.4.4 0 0 0-.4-.4H7.783C4.623 2.5 2.5 4.721 2.5 8.026v2.824c0 .22.18.4.4.4zM13.15 12.75a.4.4 0 0 0-.4.4v7.95c0 .22.18.4.4.4h3.067c3.16 0 5.283-2.221 5.283-5.526V13.15a.4.4 0 0 0-.4-.4zM11.25 13.15a.4.4 0 0 0-.4-.4H2.9a.4.4 0 0 0-.4.4v2.824c0 3.305 2.123 5.526 5.283 5.526h3.067a.4.4 0 0 0 .4-.4z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTableFilled);
export default ForwardRef;
